/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StationsStationsGetAllQueryResponse, StationsStationsGetAllQueryParams } from "../models/StationsStationsGetAll";

export function getStationsStationsGetAllUrl() {
  const res = { method: 'GET', url: `/stations/v1` as const }
  return res
}

/**
 * @description Returns all stations accessible to the authenticated client or user.
 * @summary List stations
 * {@link /stations/v1}
 */
export async function stationsStationsGetAll(params?: StationsStationsGetAllQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StationsStationsGetAllQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getStationsStationsGetAllUrl().url.toString(), params, ... requestConfig })
  return res.data
}